import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const GiftWrapAttributes = ({
  isLoading,
}) => (
  <fieldset className="cart-gift-wrap__attributes">
    <label className="form-control custom-checkbox-wrapper" htmlFor="cart-attr--wrap-together">
      <input
        id="cart-attr--wrap-together"
        type="radio"
        name="attributes[Gift Wrapping]"
        value="Wrap all items together"
        checked
        disabled={isLoading}
        readOnly
      />
      <span className="custom-checkbox__icon" />
      <span>Wrap all items together</span>
    </label>
    <label className="form-control custom-checkbox-wrapper" htmlFor="cart-attr--wrap-separately">
      <input
        id="cart-attr--wrap-separately"
        type="radio"
        name="attributes[Gift Wrapping]"
        value="Wrap all items seperately"
        disabled={isLoading}
        readOnly
      />
      <span className="custom-checkbox__icon" />
      <span>Wrap all items seperately</span>
    </label>
  </fieldset>
);

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
});

const mapDispatchToProps = {
};

GiftWrapAttributes.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

GiftWrapAttributes.defaultProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(GiftWrapAttributes);
